import ajax from '../http/ajax'

export const getSmsCode = (data) => {
    return ajax.get('getSmsCode', data)
}

/**
 * 获取发送短信验证码次数
 */
export const getSendSmsCount = (data) => {
    return ajax.get('getSendSmsCount', data)
}
